import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DatePipe } from '@angular/common'

import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { LoantransactionService } from "./../../loan/shared/loantransaction.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationdialogService } from "../../utility/shared/confirmationdialog.service";
import { Document } from "./../../helpers/document";
import { PrivilegeService } from "./../../staff/Shared/privilege.service";

@Component({
  selector: 'app-holidaycollection',
  templateUrl: './holidaycollection.component.html',
  styleUrls: ['./holidaycollection.component.css']
})
export class HolidaycollectionComponent implements OnInit {

  TransactionNo: number;
  AddButtonText: string;
  ErrorText: string;
  PaymentModeList: any[] = [];
  CentreList: any[] = [];
  btnvisibility: boolean = true;
  BankLedgerVisibility: boolean = false;
  BankLedgerList: any[] = [];
  toast: Toastpayload;
  TotalLoanDemand: Number;
  TotalSavingDemand: Number;
  TotalDemand: Number;
  TableRowCount: Number;

  IsAdd: boolean;
  IsEdit: boolean;
  IsDelete: boolean;
  IsView: boolean;
  IsPrint: boolean;

  constructor(public loantransactionService: LoantransactionService, private router: Router,
    private commonmastersService: CommonmastersService,
    private route: ActivatedRoute, private datePipe: DatePipe,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService,
    private confirmationdialogService: ConfirmationdialogService,
    private privilegeService: PrivilegeService,) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.TransactionNo = +  params['Id']; // (+) converts string 'id' to a number
    });

    this.GetPaymentMode();
    this.GetCentreList();
    this.GetBankLedgerList();
    this.resetForm();
    this.GetAutogeneratedNumber();
    if (Number.isNaN(this.TransactionNo)) {
      this.loantransactionService.selectedLoantransaction.Id = 0;
      this.loantransactionService.selectedLoantransaction.Flag = 1;
      this.loantransactionService.selectedLoantransaction.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.loantransactionService.selectedLoantransaction.Id = +this.TransactionNo;
      this.loantransactionService.selectedLoantransaction.Flag = 2;
      this.loantransactionService.selectedLoantransaction.IsActive = true;
      this.AddButtonText = "Edit & Save";
    }

    // Getting page permissions
    const DocumentId = 3043; //Document.Loantransaction;
    this.PageSecurity(DocumentId);
  }

  resetForm(form?: NgForm) {

    this.TableRowCount = 0; //

    if (form != null)
      form.reset();

    this.loantransactionService.selectedLoantransaction = {
      Id: 0,
      TransactionNo: 0,
      LoanId: 0,
      CentreId: 0,
      TransactionDate: new Date().toISOString().substring(0,10),
      // TransactionDate:this.datePipe.transform(new Date().toISOString().substring(0,10), 'dd/MM/yyyy'),
      CollectionAmount: null,
      PrincipleAmount: null,
      InterestAmount: null,
      BalanceAmount: 0,
      InstallmentNo: 0,
      IsPartPayment: false,
      IsLoanPreclosure: false,
      IsDeath: false,
      IsReceiptAmount: false,
      PaymentTypeId: 0,
      PaymentBankId: 0,
      ChequeNo: null,
      Remarks: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: true,
      Flag: null,
      ListByCentreId: true,

      CustomerName: null,
      LoanApprovedDate: null,
      LoanDemand: null,
      TotalDemand: null,
      SavingsId: null,
      SavingsDemand: null,
      DepositDate: null,
      IsOpening: false,

      GroupLoanDemand: 0,
      GroupSavingsDemand: 0,
      GroupTotalDemand: 0,

    }
  }

  GetCentreList() {
    this.commonmastersService.FetchCenterList()
      .toPromise()
      .then(data => {
        this.CentreList = data;
      })
  }

  GetBankLedgerList() {
    this.loantransactionService.FetchBankLedgerList()
      .toPromise()
      .then(data => {
        this.BankLedgerList = data;
      })
  }

  GetAutogeneratedNumber(): any {
    if (this.loantransactionService.selectedLoantransaction.TransactionNo == 0) {
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.loantransactionService.selectedLoantransaction.TransactionNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      // here is the foreign key issue.
      this.loantransactionService.selectedLoantransaction.Id = + this.TransactionNo;
    }
  }

  GetPaymentMode() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentModeList = data;
      // Id = 1 Name ='Cash' , Id = 2 Name ='Bank' , Id = 3 Name ='Deposit' ;
    })
  }

  selectChange(CentreId: any): void {
    this.btnvisibility = true;
    this.loantransactionService.FetchLoantransactionByCentre(CentreId)
      .toPromise()
      .then(data => {

        this.loantransactionService.LoantransactionList = data;
        this.TotalLoanDemand = this.loantransactionService.LoantransactionList[0].GroupLoanDemand;
        this.TotalSavingDemand = this.loantransactionService.LoantransactionList[0].GroupSavingsDemand;
        this.TotalDemand = this.loantransactionService.LoantransactionList[0].GroupTotalDemand;
        this.TableRowCount = this.loantransactionService.LoantransactionList.length; // to dispaly no data
        this.loantransactionService.selectedLoantransaction.TransactionDate = new Date().toISOString().substring(0,10),
        this.ErrorText = "";

        // console.log(this.loantransactionService.LoantransactionList.length);
        // console.log(this.TableRowCount);
      });
  }

  editRowID: any = '';
  Edit(LoanId: any): void {
    this.editRowID = LoanId;
  }

  onSubmit(form: NgForm) {

    this.toast = {
      message: "No Message Now!",
      title: 'Loan Collection.!',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };
    // clearing the initial error message, if any.
    this.ErrorText = "";

    if (form.value.CentreId != 0 && form.value.PaymentTypeId != 0 && this.loantransactionService.LoantransactionList.length > 0) {

      //check if bank ledger selected, if payment type is Bank
      if (form.value.PaymentTypeId == 2) {
        if (form.value.PaymentBankId == 0) {
          this.toast.message = 'Savings failed, due to selection of Bank.'
          this.toast.type = 'error';
          this.toasterserviceService.showToast(this.toast);
          this.ErrorText = "Please select Bank";
          return;
        }
      }

      // showing Loader 
      this.ngxLoader.start();
      // Id = 1 Name ='Cash' , Id = 2 Name ='Bank' , Id = 3 Name ='Deposit' ;
      let PType: string = form.value.PaymentTypeId == 1 ? "Cash" : form.value.PaymentTypeId == 2 ? "Bank" : "Deposit";
      //conformation dialog box
      let title: string = "Confirmation";
      let message: string = "The selected payment type is " + PType + " and collection date is " + form.value.TransactionDate +". Do you want to continue?";
      let btnOkText: string = "Yes";
      let btnCancelText: string = 'No, Exit';

      this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
        .subscribe(confirmed => {
          if (confirmed == true) {

            this.btnvisibility = false;
            this.loantransactionService.IUDLoantransactionList(this.loantransactionService.LoantransactionList, form)
              .subscribe(data => {
                // transaction No. regeneration, otherwise same trans No. will use next centres.
                this.GetAutogeneratedNumber();
                if (data[0].ResponseStatus = 500) {
                  this.toast.message = 'Loan collection amounts savings failed!'
                  this.toast.type = 'error';
                  this.toasterserviceService.showToast(this.toast);
                  this.ErrorText = data[0].ResponseMessage
                }
                else {
                  this.toast.message = 'Loan collection amounts successfully saved!'
                  this.toast.type = 'success';
                  this.toasterserviceService.showToast(this.toast);

                  this.router.navigate(['/loantransaction']);
                  this.ErrorText = "Successfully Saved.";
                }
              })
          }
        })
    }
    else {
      this.toast.message = 'Savings failed, due to Centre or Payment type.'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      this.ErrorText = "Please select Centre and Payment Type";
    }
    // Closing Loader
    this.ngxLoader.stop();
  }

  ShowBankList(Id: number) {

    if (Id == 2)//Bank
    {
      this.BankLedgerVisibility = true;
    }
    else {
      this.BankLedgerVisibility = false;
    }
  }

  PageSecurity(DocumentId: number) {
    console.log("PageSecurity is calling")
    this.privilegeService.GetPageSecuritybyRoleId(DocumentId).toPromise()
      .then(data => {
        if (data !== null) {
          this.IsAdd = data.IsAdd;
          this.IsEdit = data.IsEdit;
          this.IsDelete = data.IsDelete;
          this.IsView = data.IsView;
          this.IsPrint = true;
          console.log(this.IsEdit);
        }
      });
  }

}

